/* WISHLIST */

let wishListItems = []
let btnWishList = document.querySelector('[data-wishlist-id]')
let countWishList = document.querySelector('[data-wishlist-count]')

let iconWishlist = '<span style="margin-left: 10px;" class="svg-wrapper"><!--?xml version="1.0" encoding="UTF-8"?--><svg id="Capa_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.52 28.67"><defs><style>.cls-1 {fill: none;stroke: #c39d5a;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.85px;}</style></defs><g id="Capa_1-2" data-name="Capa_1"><path class="cls-1" d="M15.83,5.62C19.27-.8,24.66,1.23,24.66,1.23c7.06,2.41,5.86,8.79,5.86,8.79.04,4.31-3.96,8.14-3.96,8.14l-10.73,9.52-.07.07-.07-.07-10.73-9.52S.96,14.32,1,10.01C1,10.01-.2,3.64,6.86,1.23c0,0,5.38-2.02,8.83,4.39l.07.14.07-.14Z"></path></g></svg></span>'

if (localStorage.getItem('wishlistItems')) {
  const savedItems = JSON.parse(localStorage.getItem('wishlistItems'));
  wishListItems = savedItems

  if (btnWishList !== null) {
    const itemId = btnWishList.dataset.wishlistId;
    const existeElemento = wishListItems.includes(itemId);
    existeElemento ? btnWishList.innerHTML = `Eliminar de Favoritos ${iconWishlist}` : btnWishList.innerHTML = `Agregar a Favoritos ${iconWishlist}`
  }
  wishListItems.length != 0 ? countWishList.classList.add('dotWishList') : countWishList.classList.remove('dotWishList')
}

function wishList() {
  const itemId = btnWishList.dataset.wishlistId;
  const existeElemento = wishListItems.includes(itemId);
  existeElemento ? removeItemWishList(itemId) : saveItemsWishList(itemId)

  countWishList.classList.add('animate-wishlist')
  setTimeout(() => {
    countWishList.classList.remove('animate-wishlist')
  }, 700);
}

function saveItemsWishList(itemId) {
  if (localStorage.getItem('wishlistItems')) {
    const savedItems = JSON.parse(localStorage.getItem('wishlistItems'));
    wishListItems = savedItems
  }
  wishListItems.push(itemId)
  localStorage.setItem('wishlistItems', JSON.stringify(wishListItems));
  btnWishList.innerHTML = `Eliminar de Favoritos ${iconWishlist}`
  wishListItems.length != 0 ? countWishList.classList.add('dotWishList') : countWishList.classList.remove('dotWishList')
}

function removeItemWishList(itemId) {
  const newWishList = wishListItems.filter(elemento => elemento !== itemId);
  localStorage.setItem('wishlistItems', JSON.stringify(newWishList));
  wishListItems = newWishList
  btnWishList.innerHTML = `Agregar a Favoritos ${iconWishlist}`
  wishListItems.length != 0 ? countWishList.classList.add('dotWishList') : countWishList.classList.remove('dotWishList')
}
